import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Coaching from "@/pages/Coaching";
import Packages from "@/pages/Packages";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import BookCall from "@/pages/BookCall";
import Onboarding from "@/pages/Onboarding";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="grain bg-ink text-ivory">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-sono" element={<About />} />
            <Route path="/coaching" element={<Coaching />} />
            <Route path="/pacchetti" element={<Packages />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="/prenota-call" element={<BookCall />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/pagamento/confermato" element={<PaymentSuccess />} />
            <Route path="/pagamento/annullato" element={<PaymentCancel />} />
            <Route path="/privacy-policy" element={<Legal page="privacy" />} />
            <Route path="/cookie-policy" element={<Legal page="cookie" />} />
            <Route path="/termini-e-condizioni" element={<Legal page="termini" />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#1C171B", border: "1px solid #2E2429", color: "#F9F4EC" } }} />
    </div>
  );
}

export default App;
